<template>
  <div >
      <search-form size='medium'
                  labelWidth='90px'
                  :searchData="search.queryCard"
                  :searchForm="search.searchForm"
                  :searchHandle="search.searchHandle">
      </search-form>
      <Table 
      ref="myTable"
      @amountChange="amountChange"
        :TableParam="Table"
        class="table">
          <template v-slot:Paging>
            <Paging @change="queryCardList(false,'change')"
              :pager="pager" />
          </template>
      </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { optionsDataReplace } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      queryCard: {},
      search: { // 搜索
        queryCard: {}, // 返回的数据
        searchForm: [
          { type: 'Input', label: '批次号：', prop: 'batchSn', placeholder: '请输入批次号' },
          { type: 'Input', label: '卡号：', prop: 'cardNo', placeholder: '请输入卡号' },
          { type: 'Input', label: '卡名称：', prop: 'cardName', placeholder: '请输入卡名称' },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: this.$map.typeProps, change: row => '', placeholder: '请选择卡类型' },
          { type: 'Input', label: '会员ID：', prop: 'bindAccount', placeholder: '请输入会员ID' },
          { type: 'Input', label: '账号名称：', prop: 'bindAccountName', placeholder: '请输入账号名称' }
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.queryCardList(true) },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      Table: { // 表格
      defaultFaceCheckBox:{
        defaultFaceChecked: false,
        defaultFaceInput: '',
      },
      primaryBtn: {
          show: true,
          html: '充值确认',
          handle: (el) => this.sure()
        },
        isHeader: true,
        paddingRight: true,
        data: [],
        el: null,
        column: [
          { prop: 'batchSn', label: '批次号' },
          { prop: 'cardNo', label: '预付卡号' },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'remaining', label: '金额' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'cardNatureName', label: '卡种类' },
          { prop: 'bindAccount', label: '会员ID' },
          { prop: 'bindAccountName', label: '账号名称' },
          { prop: 'amount', label: '充值金额（元）', type: 'amount'},
        ]
      },
      multipleSelection: [], // 选中的列
      topUpMoney: null,
      cardNatureOptions: [
            // {name:'定额卡', id:0},
            {name:'不定额卡', id:1},
            {name:'动态充值卡', id:2},
          ],
    cardNatureObj:{
        0: '定额卡',
        1: '不定额卡',
        2: '动态充值卡'
      },
    saveObj:{},
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    'Table.defaultFaceCheckBox.defaultFaceInput':{
      deep: true,
      handler(v){
        if(!/^([-?[0-9]{0,4}|[0-9])+.?[0-9]{0,2}$/.test(Number(v))){
          this.$message.error('最多两位小数!')
        }
        if(Number(v)>999999999){
          this.Table.defaultFaceCheckBox.defaultFaceInput = 999999999
        }
        if(Number(v)<-999999999){
          this.Table.defaultFaceCheckBox.defaultFaceInput = -999999999
        }
        this.setAllInputValue(v)
      }
    },
    'Table.defaultFaceCheckBox.defaultFaceChecked':{
      deep: true,
      handler(v){
        if(v){

        }else{
          this.saveObj = {}
          this.Table.data = this.Table.data.map(item=>{
            return {
              ...item,
              amount: null
            }
          })
        }
      }
    }
  },
  // 方法集合
  methods: {
    setAllInputValue(v){
      if(v){
          this.saveObj = {}
          this.Table.data = this.Table.data.map(item=>{
            return {
              ...item,
              amount: Number(v) || null
            }
          })
          this.Table.data.forEach(item=>{
              this.saveObj[item.id] = {...item}
          })
        }else{
          this.saveObj = {}
          this.Table.data = this.Table.data.map(item=>{
            return {
              ...item,
              amount:  null
            }
          })
        }
    },
    // 充值确认
    async sure(){
      // let promisAll = []
      // this.$refs.myTable.$refs.myTableForm.forEach(item=>{
      //   promisAll.push(item.validate())
      // })
      // Promise.all(promisAll).then(()=>{
        if(JSON.stringify(this.saveObj)=='{}'){
        return
      }
      const flage1 = Object.values(this.saveObj).some(item=>{
        return !/^([-?[0-9]{0,4}|[0-9])+.?[0-9]{0,2}$/.test(Number(item.amount))
      })
      if(flage1){
        this.$message.error('最多两位小数!')
        return
      }
      let defaultFaceChecked = this.Table.defaultFaceCheckBox.defaultFaceChecked
      let defaultFaceInput = this.Table.defaultFaceCheckBox.defaultFaceInput
      let arr = []
      if(defaultFaceChecked && defaultFaceInput){
        if(!/^([-?[0-9]{0,4}|[0-9])+.?[0-9]{0,2}$/.test(Number(defaultFaceInput))){
          this.$message.error('最多两位小数!')
          return
        }
        const { pager, } = this
        const param = { 
          pageNum: 0,
          pageSize: 0,
          ...this.search.queryCard,
          rechargedTable: true,
          cardNature: 2
        }
      let nowRes = await this.$http.getCardPagination(param)
      if(nowRes.status == 200){
        nowRes.data.list.forEach(i=>{
          arr.push({
            id: i.id,
            amount: Number(defaultFaceInput),
          })
        })
      }
      }else{
        for(let i in this.saveObj){
        if(this.saveObj[i].amount!=''){
          arr.push({
            id: this.saveObj[i].id,
            amount: Number(this.saveObj[i].amount),
          })
          }
        }
      }
      if(arr.length==0){
        return
      }
      this.$http.batchJudgeTopUpMoney(arr)
        .then((res) => {
          if (res.status === 200) {
            this.saveObj = {}
            this.Table.defaultFaceCheckBox.defaultFaceChecked = false
            this.Table.defaultFaceCheckBox.defaultFaceInput = null
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        }).finally(() => {
          this.queryCardList()
        })
        // }).catch(e=>{
        // })
    },
    // 充值金额输入
    amountChange(row){
      this.Table.data = this.Table.data.map(item=>{
        if(Number(row.amount)>999999999 && item.id==row.id){
          return{
            ...item,
            amount: 999999999
          }
        }else if(Number(row.amount)<-999999999 && item.id==row.id){
          return{
            ...item,
            amount: -999999999
          }
        }
        else{
          return item
        }
      })
      this.Table.data.forEach(item=>{
        if(item.id==row.id){
          this.saveObj[row.id] = {...item}
        }
      })
      // this.saveObj[row.id] = {...row}
    },
    // 点击重置按钮
    searchResetForm () {
      this.search.queryCard = {}
      this.saveObj = {}
      this.queryCardList()
    },

    queryCardList (flag,change='') {
      const { pager, } = this
      const param = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...this.search.queryCard,
        rechargedTable: true,
        cardNature: 2
      }
      this.$http.getCardPagination(param)
        .then((res) => {
          if (res.status === 200) {
            let defaultFaceChecked = this.Table.defaultFaceCheckBox.defaultFaceChecked
            let defaultFaceInput = this.Table.defaultFaceCheckBox.defaultFaceInput
            if(defaultFaceChecked && (defaultFaceInput || defaultFaceInput == 0)){
              this.Table.data = res.data.list.map(item=>{
                  return {
                    ...item,
                    cardNatureName: this.cardNatureObj[item.cardNature],
                  }
                })
              this.setAllInputValue(defaultFaceInput)
            }else{
              if(change == 'change' && JSON.stringify(this.saveObj)!='{}'){
                let temp = []
                temp = res.data.list.map(item=>{
                  return {
                    ...item,
                    cardNatureName: this.cardNatureObj[item.cardNature],
                    amount: (this.saveObj[item.id] || {}).amount || null
                  }
                })
                this.Table.data = temp
              }else{
                this.saveObj = {}
                this.Table.data = res.data.list.map(item=>{
                  return{
                    ...item,
                    cardNatureName: this.cardNatureObj[item.cardNature],
                    amount: null,
                  }
                })
              }
            }
            this.pager.count = res.data.total
            flag && this.$message.success(res.msg)
          } else {
            flag && this.$message.error(res.msg)
          }
        })
    },
    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            optionsDataReplace('cardTypeId', this.search.searchForm, (res.data || []))
          }
        })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getCardTypeList()
    this.queryCardList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
</style>
